// Adapted from https://github.com/Azure-Samples/ms-identity-b2c-javascript-spa
/**
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
import {useMsalStore} from '@/store/msal'

// b2cPolicies is built lazily on first access so this module is safe to
// static-import before app.use(pinia) runs. The outer Proxy preserves the
// `b2cPolicies.names.signUpSignIn` / `b2cPolicies.authorityDomain` API used
// by authPopup.js — callers still see a plain object.
let cachedPolicies = null
function buildPolicies() {
    if (cachedPolicies) return cachedPolicies
    const msalStore = useMsalStore()
    const susiAuthority = 'https://' + msalStore.authorityDomain + '/pattanb2c.onmicrosoft.com/' + msalStore.policy
    cachedPolicies = {
        names: {
            signUpSignIn: msalStore.policy,
            editProfile: msalStore.policy,
        },
        authorities: {
            signUpSignIn: {
                authority: susiAuthority,
            },
            editProfile: {
                authority: susiAuthority,
            },
        },
        authorityDomain: msalStore.authorityDomain,
    }
    return cachedPolicies
}

export default new Proxy({}, {
    get(_, key) {
        return buildPolicies()[key]
    },
})
